export function createMapFromArray<Item, Key = string, Value = Item>(
    arr: Item[],
    cb: (item: Item) => [Key, Value]
): Map<Key, Value> {
    return new Map(arr.map(cb));
}
